import Common from '../../../stores/Common';
import { DisplayMessages } from '../../../utilities/DisplayMessages';
import { Link } from 'react-router-dom';
import { LoaderAnimation } from '../../shared/Loader';
import { LocalRoutes } from '../../../utilities/LocalRoutes';
import { useCaseFileContext } from '../../../contexts/useCaseFileContext';
import { useGetBestFitCases } from './data/useGetBestFitCases';
import { useZoneContext } from '../../../contexts/useZoneContext';

export function BestFitCases(props: { isReady: boolean }) {
    const caseFile = useCaseFileContext();
    const { data, isLoading, isError } = useGetBestFitCases(
        props.isReady,
        caseFile.currentCase.guid
    );
    const { buildZoneUrl } = useZoneContext();

    if (isLoading) {
        return <LoaderAnimation size="xs" variant="secondary" />;
    }

    if (isError) {
        return <div className="text-danger">{DisplayMessages.UnexpectedError}</div>;
    }

    return (
        <table className="table mt-1" style={{ position: 'relative' }}>
            <thead className="sticky-header background-grey">
                <tr>
                    <th>Case Name</th>
                    <th>Status</th>
                    <th>Jurisdiction</th>
                    <th>Plaintiffs Firm</th>
                    <th>Disease</th>
                    <th>Final Settlement</th>
                </tr>
            </thead>
            <tbody>
                {data?.map((item, idx) => (
                    <tr key={idx}>
                        <td>
                            <Link
                                target="_blank"
                                to={buildZoneUrl(LocalRoutes.CaseFile.replace(':guid', item.caseGuid))}
                            >
                                {item.caseName}
                            </Link>
                        </td>
                        <td>{item.status}</td>
                        <td>{item.jurisdiction}</td>
                        <td>{item.plaintiffsFirm}</td>
                        <td>{item.disease}</td>
                        <td>
                            {item.finalSettlement
                                ? Common.formatCurrency(item.finalSettlement.toString())
                                : ''}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
